
import {
  React, ReactDOM,

  Ajax, AppBase, DataStore, Moment
} from 'app/react/Boot.jsx';

var _s = require('underscore.string');

var ConsoleWidget = null;

//const BASE_URL = "http://x34.dacsystem.pl/bielany/bielany.php";
//const BASE_URL = "http://localhost";
//const BASE_URL = "https://x34.dacsystem.pl/bielany/bielany.php";

const AJAX_CONF_DYNAMIC = {

    // causes filename param to be treated as path and appended to url
    filename: true,

    // determines whether to use static api (file based), or
    apiType: 'dynamic',

    mapping: {

      when: [
        /^https\:\/\/cas14\.dacsystem\.pl\/cas_envag\/.*/,
        /\/cas_envag\/.*/,
        /^https\:\/\/cas14\.dacsystem\.pl\/cas_pm\/.*/,
        /\/cas_pm\/.*/,
        /^https\:\/\/o17\.dacsystem\.pl\/.*/,
        /.*/,
        /^https\:\/\/data\.dusbox\.pl\/.*/,
        /.*/,
      //  /^http\:\/\/pmpro\.dacsystem\.pl\/.*/,
      //  /.*/
      ],

      rules: [
        {
          endsWith: ".def",
          replaceWith: "json/do?table=ChemicalCompound&v=2"
        },
        {
          endsWith: ".cfg",
          replaceWith: "json/do?table=Measurement&v=2"
        },
        {
          endsWith: ".dat",
          replaceWith: "data/averages"
        },
        {
          endsWith: "_24h.dat",
          replaceWith: "data/averages"
        },
        {
          endsWith: ".now",
          replaceWith: "data/samples"
        }
      ]
    }
};

const ADDITIONAL_PARAMS = {
  // beforeSend: function (xhr) {
  //   console.log('running before send: ', xhr)
  //   xhr.setRequestHeader ("Authorization", "Basic " + btoa("tkosiak:qwerty"));
  // }
}

const AJAX_CONF_LEGACY = {
  filename: false
}

var AJAX_CONF  = AJAX_CONF_DYNAMIC;
var BASE_URL = "";

// const BASE_URL = "";
//const BASE_URL = "../data";
//const BASE_URL = "/data";
//const BASE_URL = "http://localhost:3000";
//const BASE_URL = "https://localhost:12443";

if (process.env.NODE_ENV == "production") {
  // BASE_URL = "/cas_envag/webapp";
  // BASE_URL = "/cas_pm/webapp";
  BASE_URL = "https://cas14.dacsystem.pl/cas_pm/webapp";

} else {
  // TEST_ENVIRONMENT
  // BASE_URL = "https://cas14.dacsystem.pl/cas_envag/webapp";
  BASE_URL = "https://cas14.dacsystem.pl/cas_pm/webapp";
}

BASE_URL = "http://o17.dacsystem.pl/webapp";
BASE_URL = "https://data.dustbox.pl/webapp";

// for excento
BASE_URL = "http://pmpro.dacsystem.pl/webapp";
BASE_URL = "https://pomorskie.cas.sensorbox.pl/webapp";

// use this if you have configured proxy 
BASE_URL = "/webapp";


import {ConsoleData} from 'app/ConsoleData.jsx';

class ConsoleBase extends AppBase {

  mergeParams(params) {

    for (var key in params) {
//      if (!this.hashParams.hasOwnProperty(key)) {
        this.hashParams[key] = params[key];
//      }
    }
  }

  constructor(widget, appType, config) {
    super(config);

    var {
      dataUrl, locParams, hashParams, prognozaUrl, loadMetadataFirst
    } = config;

    // console widget object, need to be global
    ConsoleWidget = widget;

    // apllication type: krynica, ustka, rabka ,,,
    this.appType = appType;
    this.queryParams = locParams;

    this.hashQueryRe = /q=(\{.*\})/;

    // ajax request
    this.ajax = new ConsoleData(new Ajax(), AJAX_CONF);

    this.hashParams = this.getUrlQueryParams();
    this.mergeParams(this.queryParams);
    this.loadMetadataFirst = loadMetadataFirst || true;

    this.stores = {
      'site': new DataStore({model: {id: 'id'}}),
      'site_by_code': new DataStore({model: {id: 'site'}}),

      'measurement_by_site': new DataStore({model: {id: 'site_code'}}),

      // sites
      'measurement': new DataStore({model: {id: 'id'}}),
      'measurement_by_code': new DataStore({model: {id: 'code'}}),
      'chemical_compound' : new DataStore({model: {id: 'compound_type'}}),
      'measurement_by_compound': new DataStore({model: {id: 'compound_type'}})
    }
  }

  initialPromises() {
    console.log('getting file type: ', this.appType + ".cfg")

    switch (this.appType) {
      case "uzdrowisko":
      case "excento":
      case "dashboard":
        return Promise.all([
          this.ajax.promise_jsonp(BASE_URL, {
            data: {
              filename: this.appType + ".cfg"
            }, ...ADDITIONAL_PARAMS
          }),
          this.ajax.promise_jsonp(BASE_URL, {
            data: {
              filename: this.appType + ".def",
            }, ...ADDITIONAL_PARAMS
          })
        ])
      case "eusluga":
        return Promise.all([

          this.ajax.promise_jsonp(BASE_URL, {
            data: {
              filename: this.appType + ".cfg"
            }, ...ADDITIONAL_PARAMS
          }),

          this.ajax.promise_jsonp(BASE_URL, {
            data: {
              filename: this.appType + ".def",
            }, ...ADDITIONAL_PARAMS
          }),

          new Promise(function (resolve, reject) {
            const json = require('app/react/eusluga/json/kk2.json');

            resolve(json);;
          })

        ])
      default:
        return Promise.all([
          this.ajax.promise_jsonp(BASE_URL, {
            data: {
              filename: this.appType + ".cfg",
            }, ...ADDITIONAL_PARAMS
          })

        ])
    }

  }

  init(target) {
    // fot now, username and password is plainly added to the url string
    //var url = "https://cas14.dacsystem.pl/cas_bielany/webapp/json/do";

    console.log('initializing: ', this.loadMetadataFirst)
    this.loadMetadataFirst && this.initialPromises().then(([json, ...args]) => {
      this.data = json;

      // i need to fix it
      json["measurement"] = json.data;

      if (args.length > 0) {
        if (["dashboard", "eusluga", "excento"].includes(this.appType)) {
          // we use different ids inside application and on server
          json["chemical_compound"] = args[0].data.map((r, i) => {return {...r, compound_type: r.id, name: r.long_name}});
        }

        if (this.appType == "eusluga") {
          json["site"] = args[1].filter((r, i) => {
            return (r.GID == "kedzierzyn" && r.active_p == "t");
          }).map((r, i) => {
            return {...r,
              Miernik: r.site,
              id: parseInt(r.ROW_NO),
              prefix: "5" + r.site.substring(2),
              ds_map: ["ds.PM10", "ds.PM25", "ds.PM01", "ds.TA", "ds.RH", "ds.PA"].map((ds) => r[ds])
            }
          });

          var siteKeys = json["site"].map((r) => r.prefix);

          // console.log('jsonsite: ', json['site'])
          this.stores["site_by_code"].setData(json["site"]);

          // filtrowanie pomiarów
          json["measurement"] = json.data.filter((r, i) => {
            var key = r.code.substring(0, 3);

            return siteKeys.some((r) => r == key);
            //return /^5.*/.test(r.code);
          }).filter((r, i) => {
            var key = r.code.substring(1, 3);


            return this.stores["site_by_code"].some((site) => {
              return site.ds_map.some((ds) => ds == r.code);
            })
            //var site = this.stores["site_by_code"].getRecordById("KK"+key);

            //return site.ds_map.some((ds) => ds == r.code);
          })
          .map((r, i) => { return {...r, site_code: "KK" + r.code.substring(1, 3)}});


          if (0) {
            // filtrowanie pomiarów
            json["measurement"] = json.data.filter((r, i) => {
              var key = r.code.substring(0, 3);

              return siteKeys.some((r) => r == key);
              //return /^5.*/.test(r.code);
            }).map((r, i) => { return {...r, site_code: "KK" + r.code.substring(1, 3)}});
          }

          this.stores["measurement_by_site"].setData(json["measurement"])
        }
      }

      // measurement by site_code,ddffsddssssaasssdsdsdadasd

      //console.log('my measurements: ', json["measurement"])

      //console.log('my retrieved data: ', json)
      for (var name in this.stores) {
        if (json[name]) {
          console.log("initializing data store: ", name)
          this.stores[name].setData(json[name]);
        } else {
          // for non standard stores
        }
      }

      console.log('initializing measurement_by_code')
      this.stores["measurement_by_code"].setData(
        this.stores["measurement"].getData()
      );

      console.log('initializing measurement_by_compound')
      this.stores["measurement_by_compound"].setData(
        this.stores["measurement"].getData()
      );

      if (!this.stores["chemical_compound"]) {

        this.stores['chemical_compound'].setData(
          this.stores["measurement_by_compound"].getIds().map((compound_type) => {
            var meas = this.getStore('measurement_by_compound').getRecordById(compound_type);
            var name;
            var color;

            if (_.isArray(meas)) {
              meas = meas[0];
            }

            switch (compound_type) {
              case "no"   : name = "Tlenek azotu"; break;
              case "no2"  : name = "Dwutlenek azotu";break;
              case "nox"  : name =  "Tlenki azotu"; break;
              case "pm1" : name =  "Pył zawieszony PM1"; break;
              case "pm10" : name =  "Pył zawieszony PM10"; break;
              case "pm2.5" : name =  "Pył zawieszony PM2.5"; break;
              case "co"   : name =  "Tlenek węgla"; break;
              case "so2"  : name =  "Dwutlenek siarki"; break;
              case "o3"   : name =  "Ozon"; break;
              case "bzn" : name =  "Benzen"; break;
              case "tln" : name =  "Toluen"; break;
              case "ebzn" : name =  "Etylobenzen"; break;

              default: name = compound_type; break;
            };

            var norm;
            switch (compound_type) {
              case "so2": norm = 20.0; break;
              case "no2": norm = 40.0; break;
              case "pm10":norm = 40.0; break;
              case 'bzn' : norm = 5.0; break;
              case 'co' : norm = 10000; break;
              default: norm = 100; break;
            }

            //  console.log('producing record for: ', name)
            return {compound_type: compound_type, agg_unit: meas.agg_unit, name: name, norm: norm}
          })
        )
      }

      console.log('initializing measurement_by_code')

      // expand unit_ids inside measurments

      this.stores["chemical_compound"].getData() &&  this.stores["measurement_by_code"].forEach((meas, i) => {
          var unit = this.stores["chemical_compound"].getRecordById(meas.compound_type);

          // this is enough
          meas.unit = unit;
        })

      console.log('rendering')

//      debugger
      console.log('rendering application')
      this.render(target);

    }).catch((err) => {
      console.log('catched error: ', err)
    });

    if (!this.loadMetadataFirst) {
      this.render(target);
    }

  }

  getStore(name) {
    return this.stores[name];
  }

  getFetchArgs(filename, params) {
    return [BASE_URL, {
      data: Object.assign(
        {
          _dc: new Date().getTime(),
          filename: filename,
        }, params
      )
    }]
  }

  fetchTxtFile(filename, params) {
    return this.ajax.promise_text(...this.getFetchArgs(filename, params));
  }

  fetchFile(filename, params) {
    return this.ajax.promise_jsonp(...this.getFetchArgs(filename, params));
  }

  download(filename, text) {
    return this.ajax.download(filename, text);
  }

  openWindow(params) {
    return this.ajax.window_open(...this.getFetchArgs(filename, params));
  }

  fetchAvgData(avg, params) {
    switch (avg) {
      case "10s": return this.fetchSamples(params);
      case "1h" : return this.fetchData(params);
      case "24h" : return this.fetch24hData(params);
      default: return this.fetchData(params);
    }
  }

  fetch24hData(params) {
    return this.fetchFile(this.appType + "_24h.dat", params);
  }

  fetchData(params) {
    return this.fetchFile(this.appType + ".dat", params);
  }

  fetchSamples(params) {
    return this.fetchFile(this.appType + ".now", params);
  }

  fetchDefinitions(params) {
    return this.fetchFile(this.appType + ".def", params);
  }

  render(target, mode, overrideParams) {

    // console.log('rendering react component in mode: ', mode, this.hashParams, this.getLocationParams())
    // hashParams are provided through reactParams ...
    // location params are hash params in url query
    // url query params are search query params in url
    var locParams = Object.assign({}, this.hashParams);

    if (overrideParams) {
      Object.assign(locParams, overrideParams);
    }

    console.log("ConsoleWidget: ", ConsoleWidget)
    ReactDOM.render(
      <div>
        <ConsoleWidget ref={(ref) => this.widget = ref} dataProvider={this} locParams={locParams}/>
      </div>,
      target
    );
  }

  parseHashParams(hash) {
    var match = this.hashQueryRe.exec(hash);

    if (match) {
      //  console.log('found hash params: ', match[1])

      return eval('(' + match[1] + ')')
    } else {
      return null;
    }
  }

  formatHashParams(params) {
    for (var key in params) {
      if (params[key] == null) {
        delete params[key];
      }
    }
    return JSON.stringify(params);
  }

  parseUrlQueryParams(query) {
    var tmp = query.substring(1).split('=');
    var key, val, result = {}, tmp2, tmp3;

    for (var i = 0; i < tmp.length; i+=2) {
      if (tmp[i] == 'q') {
        result = {};
        tmp2 = tmp[i+1].split(',');

        for (var j = 0; j < tmp2.length; j++) {
          tmp3 = tmp2[j].split(':');

          key = tmp3[0];
          val = tmp3[1];

          result[key] = val;
        }
        break;
      }
    }

    return result;
  }

  getLocationParams() {
    return this.parseHashParams(window.location.hash);
  }

  getUrlQueryParams () {
    return this.parseUrlQueryParams(window.location.search);
  }

  setLocationParams(params) {
    var existingParams = this.getLocationParams();
    var queryParams = this.formatHashParams(Object.assign({}, params));

    // delete those that are null in params
    if (queryParams == "{}") {
        window.location.hash = window.location.hash.replace(this.hashQueryRe, "");
    } else {
      if (existingParams) {
        //  console.log('replacing: ', this.hashQueryRe, queryParams);
        window.location.hash = window.location.hash.replace(this.hashQueryRe, "q=" + queryParams);
      } else {
        window.location.hash += ("q=" + queryParams);
      }
    }
  }
}

export default ConsoleBase;



// WEBPACK FOOTER //
// ./app/ConsoleBase.jsx